"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = formatPrice;
function formatPrice(price) {
  var thousandSeparator = " ";
  var decimalSeparator = ",";
  return price.toFixed(2).replace(".", decimalSeparator).replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator) + " €";
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/NumberUtil.js
 ** module id = 313
 ** module chunks = 0
 **/